import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper';


class Sefooter extends Component {

    render() {
        return (
            <div >
                <a href='' 
                    onClick={onUnsubClick} target="_blank">SÄGA UPP</a>
            </div>
        );
    }
}

export default Sefooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/sefooter.js